export const ATM_SUBMIT_SUCCESS_MESSAGE = 'Advanced Tag Mapping settings saved successfully!';
export const ATM_SUBMIT_FAILURE_MESSAGE =
  'Unable to save current Advanced Tag Mapping settings due to an unknown issue!';

export const TABLE_VALIDATION_UNIQUE_VALUES_ERROR_MESSAGE = 'Values should be unique!';
export const MANDATORY_FIELDS_VALIDATION_ERROR_MESSAGE = 'Please enter all mandatory fields';

export const MAX_DECIMAL_FIELD_TOOLTIP = 'Enter maximum number of decimal points';
export const RANGE_FIELD_TOOLTIP =
  'Set a range to limit which values the users can enter for this tag in the Controller widget';

export const MAX_VALUE_INVALID = 'Maximum value must be greater than minimum value!';
export const MIN_VALUE_INVALID = 'Minimum value must be less than maximum value!';
export const MINUS_SIGN_ISSUE = 'Value should be a number!';
